/**
 * TemplateWorkflowPage - Template workflow management dashboard
 *
 * Surfaces the TemplateWorkflowDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides workflow template browsing, versioning, and deployment capabilities.
 *
 * Route: /admin/template-workflow
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconTemplate } from '@tabler/icons-react';

import { TemplateWorkflowDashboard } from '@ferp/workflow-forms';
import { useAuth, useHasRole } from '@/auth/AuthContext';

export function TemplateWorkflowPage() {
  const { tenant } = useAuth();
  const isArchitect = useHasRole('architect');
  const isAdmin = useHasRole('admin');
  const userRoles = [
    isArchitect && 'architect',
    isAdmin && 'admin',
    'user',
  ].filter(Boolean) as string[];

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="cyan">
            <IconTemplate size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Template Workflows</Title>
            <Text size="sm" c="dimmed">
              Workflow template library, versioning, and deployment management
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <TemplateWorkflowDashboard tenantId={tenant?.id ?? ''} userRoles={userRoles} />
    </Container>
  );
}

export default TemplateWorkflowPage;
